import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { Wrapper } from "@googlemaps/react-wrapper";
import ModalComponent from '../modalComponent';
const MapModalLocationsLegacy = ({ isShown, hide, defaultLocation = "Miami, FL, USA", locationInfo, locations = [], customClass = "map-locations-aviability", onShowCarsClick }) => {
    var _a, _b;
    const allLocations = [...locations];
    if (locationInfo && !locations.find(loc => loc.address === locationInfo.address)) {
        allLocations.push(locationInfo);
    }
    const MyMapComponent = () => {
        const mapRef = useRef(null);
        const markersRef = useRef([]);
        const infoWindowsRef = useRef([]);
        useEffect(() => {
            if (!mapRef.current)
                return;
            const customMapStyle = [
                {
                    featureType: "administrative",
                    elementType: "all",
                    stylers: [
                        {
                            saturation: "-100",
                        },
                    ],
                },
                {
                    featureType: "administrative.province",
                    elementType: "all",
                    stylers: [
                        {
                            visibility: "off",
                        },
                    ],
                },
                {
                    featureType: "landscape",
                    elementType: "all",
                    stylers: [
                        {
                            saturation: -100,
                        },
                        {
                            lightness: 65,
                        },
                        {
                            visibility: "on",
                        },
                    ],
                },
                {
                    featureType: "poi",
                    elementType: "all",
                    stylers: [
                        {
                            saturation: -100,
                        },
                        {
                            lightness: "50",
                        },
                        {
                            visibility: "off",
                        },
                    ],
                },
                {
                    featureType: "road",
                    elementType: "all",
                    stylers: [
                        {
                            lightness: "50",
                        },
                        {
                            saturation: "-100",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "all",
                    stylers: [
                        {
                            visibility: "simplified",
                        },
                    ],
                },
                {
                    featureType: "road.arterial",
                    elementType: "all",
                    stylers: [
                        {
                            lightness: "30",
                        },
                    ],
                },
                {
                    featureType: "road.local",
                    elementType: "all",
                    stylers: [
                        {
                            lightness: "0",
                        },
                    ],
                },
                {
                    featureType: "transit",
                    elementType: "all",
                    stylers: [
                        {
                            saturation: -10,
                        },
                        {
                            visibility: "simplified",
                        },
                    ],
                },
                {
                    featureType: "water",
                    elementType: "geometry",
                    stylers: [
                        {
                            hue: "#ffff00",
                        },
                        {
                            lightness: 50,
                        },
                        {
                            saturation: -97,
                        },
                    ],
                },
                {
                    featureType: "water",
                    elementType: "labels",
                    stylers: [
                        {
                            lightness: -25,
                        },
                        {
                            saturation: -100,
                        },
                    ],
                },
            ];
            const map = new google.maps.Map(mapRef.current, {
                zoom: 14,
                disableDefaultUI: false,
                zoomControl: false,
                styles: customMapStyle,
                fullscreenControl: false,
                streetViewControl: false,
                cameraControl: false,
                mapTypeControl: false,
            });
            const geocoder = new google.maps.Geocoder();
            if (allLocations.length === 0 && defaultLocation) {
                geocoder.geocode({ address: defaultLocation }, (results, status) => {
                    if (status === google.maps.GeocoderStatus.OK && results && results.length > 0) {
                        const location = results[0].geometry.location;
                        map.setCenter(location);
                    }
                });
                return;
            }
            // Calcular el centro promedio de todas las ubicaciones
            let totalLat = 0;
            let totalLng = 0;
            let processedCount = 0;
            const createPinIcon = (color) => {
                return {
                    path: 'M12 0.5C18.3401 0.5 23.5 5.65994 23.5 12C23.5 16.0177 21.691 20.3419 18.2109 24.8438H18.21C16.9201 26.5116 15.6354 27.897 14.6689 28.8672C14.1856 29.3524 13.7808 29.7352 13.4941 29.998C13.3509 30.1294 13.2364 30.2315 13.1562 30.3018C13.1163 30.3368 13.0841 30.3648 13.0605 30.3848C13.049 30.3945 13.0377 30.4035 13.0283 30.4111C13.024 30.4147 13.0176 30.4195 13.0107 30.4248C13.0096 30.4257 13.0077 30.4264 13.0059 30.4277C12.7188 30.6762 12.3606 30.7939 12 30.7939C11.6247 30.7939 11.2505 30.6683 10.958 30.3984L10.8906 30.3359C10.8775 30.3242 10.8622 30.3106 10.8447 30.2949C10.7684 30.2266 10.6565 30.1262 10.5146 29.9961C10.2308 29.7357 9.82738 29.3567 9.34375 28.874C8.37698 27.9091 7.0871 26.5265 5.78906 24.8428C2.30935 20.3411 0.5 16.0175 0.5 12C0.500001 5.65994 5.65994 0.5 12 0.5ZM12 6.96387C9.20024 6.96387 6.91992 9.24419 6.91992 12.0439C6.91992 14.8446 9.18645 17.124 12 17.124C14.7998 17.124 17.0801 14.8437 17.0801 12.0439C17.0801 9.24419 14.7998 6.96387 12 6.96387Z',
                    fillColor: color,
                    fillOpacity: 1,
                    strokeWeight: 0,
                    rotation: 0,
                    scale: 1,
                    anchor: new google.maps.Point(12, 22),
                };
            };
            function centerMap() {
                const centerLat = totalLat / allLocations.length;
                const centerLng = totalLng / allLocations.length;
                map.setCenter({ lat: centerLat, lng: centerLng });
            }
            function addMarker(position, location, map, index) {
                const marker = new google.maps.Marker({
                    position: position,
                    map: map,
                    title: location.title,
                    animation: google.maps.Animation.DROP,
                    icon: createPinIcon('#000000'),
                });
                markersRef.current.push(marker);
                const infoWindow = new google.maps.InfoWindow({
                    content: createInfoWindowContent(location),
                    maxWidth: 352,
                    minWidth: 352,
                    disableAutoPan: false,
                    pixelOffset: new google.maps.Size(0, -5),
                });
                infoWindowsRef.current.push(infoWindow);
                marker.addListener('click', () => {
                    // Restaurar todos los markers a negro
                    markersRef.current.forEach(m => {
                        m.setIcon(createPinIcon('#000000'));
                    });
                    // Cambiar el marker clickeado a naranja
                    marker.setIcon(createPinIcon('#FF6600'));
                    // Cerrar todos los InfoWindows y abrir el actual
                    infoWindowsRef.current.forEach(iw => iw.close());
                    infoWindow.open({
                        anchor: marker,
                        map,
                    });
                });
            }
            allLocations.forEach((location, index) => {
                if (location.lat && location.lng) {
                    totalLat += location.lat;
                    totalLng += location.lng;
                    processedCount++;
                    addMarker({ lat: location.lat, lng: location.lng }, location, map, index);
                    if (processedCount === allLocations.length) {
                        centerMap();
                    }
                }
                else {
                    geocoder.geocode({ address: location.address }, (results, status) => {
                        if (status === google.maps.GeocoderStatus.OK && results && results.length > 0) {
                            const coords = results[0].geometry.location;
                            totalLat += coords.lat();
                            totalLng += coords.lng();
                            processedCount++;
                            addMarker(coords, location, map, index);
                            if (processedCount === allLocations.length) {
                                centerMap();
                            }
                        }
                    });
                }
            });
            map.addListener('idle', () => {
                allLocations.forEach((location, index) => {
                    const buttonId = `show-cars-button-${index}`;
                    const button = document.getElementById(buttonId);
                    if (button) {
                        button.addEventListener('click', () => {
                            if (onShowCarsClick) {
                                onShowCarsClick(location);
                            }
                        });
                    }
                });
            });
        }, [allLocations.length]);
        const createInfoWindowContent = (info) => {
            const index = allLocations.indexOf(info);
            const buttonId = `show-cars-button-${index}`;
            return `
        <style>            
          .gm-style .gm-style-iw.gm-style-iw-c {
            padding: 1rem !important;
            border-radius: 24px;
            box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.25);
            max-width: calc(100vw - 3rem) !important;
            min-width: calc(100vw - 3rem) !important;
            position: fixed;
            top: 47vh;
          }

          .gm-style .gm-style-iw-d {
            width: auto !important;
            overflow: hidden !important;
          }

          .gm-style .gm-style-iw-chr {
            position: absolute !important;
            right: 0;
            top: 0;
          }

          .map-info-title {
            color: #000;
            font-family: Open Sans;
            font-weight: 700;
            font-size: 18px;
            line-height: 24px;
            letter-spacing: 0;
            margin-bottom: .5rem;
            margin-top: 0;
            max-width: 300px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          .map-info-address,
          .map-info-price {
            color: #000;
            font-family: Open Sans;
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
            margin-bottom: 1rem;
          }

          .map-info-price strong {
            font-weight: 700;
          }

          .map-info-button {
            color: white;
            border-radius: 24px;
            cursor: pointer;
            width: 100%;
            background: linear-gradient(225deg, #FF8B01 0%, #FF6600 100%);
            border: none;
            font-family: Open Sans;
            font-weight: 700;
            font-size: 18px;
            text-align: center;
            vertical-align: middle;
            height: 3rem;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          @media screen and (min-width: 992px) {
            .gm-style .gm-style-iw.gm-style-iw-c {
              top: auto;
              width: max-content;
              position: absolute;
              min-width: 352px !important;
              max-width: 352px !important;
            }
          }
        </style>
        <div class="map-info-window">
          <h3 class="map-info-title">${info.title}</h3>
          <p class="map-info-address">${info.address}</p>
          ${info.price ? `<p class="map-info-price">Total por ${info.days || 0} días: <strong>${info.price}</strong></p>` : ''}
          ${info.carsCount ? `<button id="${buttonId}" class="map-info-button">MOSTRAR ${info.carsCount} AUTOS</button>` : ''}
        </div>
      `;
        };
        return _jsx("div", { ref: mapRef, style: { width: "100%", height: "100%" } });
    };
    return (_jsx(ModalComponent, { isShown: isShown, hide: hide, customClass: customClass, modalContent: _jsx(Wrapper, { apiKey: (_b = (_a = process.env.REACT_APP_GOOGLE_API_KEY) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "default-api-key", children: _jsx("div", { style: { width: '100%', height: '500px' }, children: _jsx(MyMapComponent, {}) }) }) }));
};
export default MapModalLocationsLegacy;
